import CornerRibbon from "./CornerRibbon";

export default CornerRibbon;
